import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import BulkInvoiceContainer from '../../containers/accounting/BulkInvoice';
import DocumentContainer from '../../containers/accounting/Document';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
//import SaveInvoiceDocumentsDialog from '../../components/Dialogs/SaveInvoiceDocuments';
import BulkQuotedPriceContainer from '../../containers/accounting/BulkQuotedPrices';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';

import ConfirmInvalidateBulkInvoiceDialog from '../../components/Dialogs/ConfirmInvalidateBulkInvoiceDialog';
import SaveInvoiceDocumentsDialog from '../../components/InvoiceDocument/SaveDialog';
import AuthUserContainer from '../../containers/AuthUser';

import { formatStatus, statusClassNames } from '../../libs/utility';

import {
	INTERNAL_TERMINAL_ID,
	MAX_GALLONS_FOR_BULK_WARNING,
	MIN_GALLONS_FOR_BULK_WARNING,
	documentTypeSort,
	getDocuments,
	invoiceStatusClassNames,
	statusToDisplay,
} from './general';

//- UI
import CheckIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import FMPHeadline from '../../components/ui/FMPHeadline';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import attachIcon from '../../images/attachDocument.svg';
import documentIcon from '../../images/document.svg';

//- Form
import FMPSubmitButton from '../../components/form/FMPSubmitButton';
import ResourceUploader from '../../components/form/ResourceUploader';
//import TerminalSupplierSelect from "../../components/form/TerminalSupplierSelect";
import BulkInvoiceSendConfirmationDialog from '../../components/Dialogs/BulkinvoiceSendConfirmationDialog';

//- Pure form
import GenericSavingDialog from '../../components/Dialogs/GenericSavingDialog';
import FMPBulkCustomerSelect from '../../components/pureForm/FMPBulkCustomerSelect';
import FMPCarrierSelect from '../../components/pureForm/FMPCarrierSelect';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPQuickbooksTermSelect from '../../components/pureForm/FMPQuickbooksTermSelect';
import FMPTerminalSelect from '../../components/pureForm/FMPTerminalSelect';
import FMPTerminalSupplierSelect from '../../components/pureForm/FMPTerminalSupplierSelect';

import FMPBulkQuotedPriceSelect from '../../components/pureForm/FMPBulkQuotedPriceSelect';

import InfoIcon from '@material-ui/icons/Info';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import FMPText from '../../components/pureForm/FMPText';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import { valueToDisplay } from '../../libs/products';

const DEFAULT_TERMINAL_SUPPLIER_VALUE = { terminalId: '', supplierId: '' };

const styles = (theme) => {
	return {
		...statusClassNames,
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 25,
			paddingBottom: 30,
			marginTop: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
		inset: {
			paddingLeft: 5,
			lineHeight: 1.3,
		},
		linkedTo: {
			fontSize: 20,
			paddingTop: 10,
		},
		linkedStatus: {
			fontSize: 15,
		},
		documentContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			borderBottom: '1px solid #F1F1F1',
			paddingBottom: 7,
			marginBottom: 7,
			marginLeft: 10,
			marginTop: 10,
		},
		documentInfoContainer: {
			display: 'flex',
			justifyContent: 'flex-start',
		},
		documentInfo: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		documentIcons: {
			whiteSpace: 'nowrap',
		},
		documentName: {
			fontWeight: 900,
		},
		button: {},
		missingDocumentName: {
			fontWeight: 900,
			color: '#777',
		},
		documentDetails: {
			fontWeight: 200,
		},
		documentRequired: {
			fontSize: 14,
			color: '#777',
		},
		missingRequiredDocs: {
			padding: 20,
			fontSize: 20,
			margin: '20px 10px',
			border: '1px solid #ddd',
			backgroundColor: '#f5f5f5',
		},
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 34,
			height: 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
		},
		attachIcon: {
			display: 'inline-block',
			width: 21,
			height: 21,
			backgroundImage: `url('${attachIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'absolute',
			bottom: 0,
			right: 0,
			transform: 'translate(30%, 30%)',
		},
		matchContainer: {
			backgroundColor: '#f7f7f7',
			padding: 15,
			fontSize: 15,
			fontWeight: 400,
			marginBottom: 10,
			marginTop: 5,
		},
		matchRow: {
			display: 'flex',
			marginBottom: 5,
		},
		warningIcon: {
			color: '#FFC107',
			width: 16,
			height: 16,
			paddingRight: 5,
			borderRight: '1px solid #f1f1f1',
			verticalAlign: 'middle',
		},
		checkIcon: {
			color: '#4CAF50',
			width: 16,
			height: 16,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
		topErrors: {
			fontSize: 18,
			padding: 20,
			border: '2px solid #f44336',
			margin: 20,
			backgroundColor: 'white',
		},
		infoBox: {
			fontSize: 14,
			alignItems: 'center',
			display: 'flex',
			backgroundColor: '#f7f7f7',
			padding: '15px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		infoIcon: {
			color: '#2196F3',
			width: 20,
			height: 20,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
		//
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
	};
};

const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
});

class SaveBulkInvoice extends Component {
	constructor(props) {
		super(props);
		const bulkInvoiceId = _.get(this.props, ['match', 'params', 'bulkInvoiceId']);

		this.state = {
			dataForFormula: undefined,
			isSaveDocumentDialogOpen: false,
			isConfirmInvalidateOpen: false,
			bulkInvoiceId: bulkInvoiceId ? parseInt(bulkInvoiceId, 10) : undefined,
			isUpdate: bulkInvoiceId,
			formFieldError: {},
			invoiceDocuments: [],
			isSendConfirmationOpen: false,
			//isSendConfirmationOpen : true,
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: undefined,

			//- Default form values
			issueDate: moment().format('YYYY-MM-DD'),
			quickbooksTermId: undefined,
			isSavingOpen: false,
			savingStatus: undefined,
			bulkInvoiceForSending: undefined,
		};
	}

	componentDidMount() {
		const {
			bulkInvoice,
			getBulkInvoice,
			carriers,
			searchCarriers,
			terminals,
			searchTerminals,
			quickbooksTerms,
			searchQuickbooksTerms,
			bulkCustomers,
			searchBulkCustomers,
		} = this.props;

		const { isUpdate, bulkInvoiceId } = this.state;

		if (_.isEmpty(carriers)) {
			searchCarriers();
		}
		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
		if (_.isEmpty(quickbooksTerms)) {
			searchQuickbooksTerms();
		}
		if (_.isEmpty(bulkCustomers)) {
			searchBulkCustomers();
		}

		//- Its always an update
		if (!isUpdate) {
			return;
		}

		if (!bulkInvoice) {
			getBulkInvoice({
				params: {
					includeQuickbooksCustomers: true,
					bulkInvoiceIds: [bulkInvoiceId],
				},
			});
		} else {
			const newState = this.getStateFromBulkInvoice(this.props);
			this.setState(newState);
		}
	}

	//componentDidUpdate(prevProps, prevState) {
	componentDidUpdate(prevProps, prevState) {
		if (_.isUndefined(prevProps.bulkInvoice) && !_.isUndefined(this.props.bulkInvoice)) {
			const newState = this.getStateFromBulkInvoice(this.props);
			this.setState(newState);
		}

		if (
			prevState.bulkCustomerId !== this.state.bulkCustomerId ||
			prevState.deliveryDate !== this.state.deliveryDate
		) {
			this.fetchQuotedPrices();
		}
	}

	getStateFromBulkInvoice = (props) => {
		const { bulkInvoice, invoiceDocumentMap, bulkCustomerMap, quickbooksCustomerMap } = props;

		if (!bulkInvoice) {
			return;
		}

		const newState = {};
		[
			'bulkCustomerId',
			'quickbooksTermId',
			'issueDate',

			'deliveryDate',
			'carrierId',
			'carrierPoNumber',
			'invoiceDocumentIds',

			'offloadTerminalId',
			'offloadBolNumbers',
			'offloadNetGallons',

			'productType',
			//'pickupTerminalId',
			//'pickupSupplierId',
			'pickupBolNumbers',
			'pickupNetGallons',

			'fuelPricePerGallon',
			'lcfsCreditPrice',
			'bulkQuotedPriceId',
		].forEach((key) => {
			if (_.isNil(bulkInvoice[key])) {
				return;
			}
			newState[key] = bulkInvoice[key];
		});

		const {
			bulkCustomerId,
			invoiceDocumentIds,
			quickbooksTermId,
			pickupTerminalId,
			pickupSupplierId,
		} = bulkInvoice;

		if (pickupTerminalId && pickupSupplierId) {
			newState.pickupTerminalSupplier = {
				terminalId: pickupTerminalId,
				supplierId: pickupSupplierId,
			};
		}

		newState.invoiceDocuments = [];
		invoiceDocumentIds.forEach((invoiceDocumentId) => {
			const invoiceDocument = invoiceDocumentMap[invoiceDocumentId] || {
				invoiceDocumentId,
				documentType: 'Missing',
			};
			newState.invoiceDocuments.push(invoiceDocument);
		});

		const errors = [];
		const bulkCustomer = bulkCustomerMap[bulkCustomerId];
		if (!bulkCustomer) {
			return this.setState({ errors: [`Major error : Missing bulk customer ${bulkCustomerId}`] });
		}

		// Future use
		newState.requireLcfsCreditPrice = false;

		const { requirePricingPerInvoice } = bulkCustomer;
		newState.requirePricingPerInvoice = requirePricingPerInvoice;

		if (!bulkCustomer.invoiceQuickbooksCustomerId) {
			errors.push(
				<div key={errors.length}>
					<span>Bulk customer needs to be linked to a quickbooks customer first. </span>
					<a href={`/logistics/bulkCustomer/update/${bulkCustomerId}`}>
						Update {bulkCustomer.name}
					</a>
				</div>
			);
		}

		if (!quickbooksTermId) {
			if (bulkCustomer.invoiceQuickbooksCustomerId && quickbooksCustomerMap) {
				const cust = quickbooksCustomerMap[bulkCustomer.invoiceQuickbooksCustomerId];
				const customerQuickbooksTermId = _.get(cust, ['SalesTermRef', 'value']);
				if (customerQuickbooksTermId) {
					newState.quickbooksTermId = customerQuickbooksTermId;
				}
			}
		}

		if (!_.isEmpty(errors)) {
			newState.errors = errors;
		}

		return newState;
	};

	fetchQuotedPrices = () => {
		const { bulkInvoice, searchBulkQuotedPrices, bulkDeliveryMap } = this.props;

		const { bulkQuotedPriceId, bulkCustomerId, deliveryDate } = this.state;

		//const { defaultDate, defaultFreightType, controller, path} = this.props;

		if (!bulkCustomerId || !deliveryDate) {
			return;
		}

		const afterDateTime = moment(deliveryDate).subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss');
		const beforeDateTime = moment(deliveryDate).add(3, 'days').format('YYYY-MM-DD HH:mm:ss');

		searchBulkQuotedPrices({
			params: {
				bulkCustomerIds: [bulkCustomerId],
				afterDateTime,
				beforeDateTime,
			},
			callback: (err, r) => {
				const bulkQuotedPrices = _.get(r, ['collections', 'bulkQuotedPriceCollection'], []);
				const newState = { bulkQuotedPrices };

				//- invoice already has a value
				if (bulkQuotedPriceId) {
					return this.setState(newState);
				}

				//- Figure out some shit and save it
				const linkedBulkDeliveryId = bulkInvoice.linkedBulkDeliveryId;
				const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

				if (!bulkDelivery) {
					return this.setState({ errors: ['Missing bulkDelivery'] });
				}

				//- Lets try to figure out the best one
				let selectedQuotedBulkPriceId = '';
				const defaultMMDD = moment(deliveryDate).format('MM_DD');
				bulkQuotedPrices.forEach((bulkQuotedPrice) => {
					const { bulkQuotedPriceId, date } = bulkQuotedPrice;

					if (moment(date).format('MM_DD') === defaultMMDD) {
						selectedQuotedBulkPriceId = bulkQuotedPriceId;
					}
				});

				if (selectedQuotedBulkPriceId) {
					newState.bulkQuotedPriceId = selectedQuotedBulkPriceId;
				}
				this.setState(newState);
			},
		});
	};

	//- Complicated because it handles values as events or paths as arrays
	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), val);
				newState[basePath] = base;
			} else {
				newState[basePath] = val;
			}
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	onTerminalSupplierChange = (value, path) => {
		const { terminalId, supplierId } = value;
		let newVal = { terminalId, supplierId };
		newVal = _.pickBy(newVal, (v) => {
			return !_.isUndefined(v);
		});

		if (_.keys(newVal).length) {
			const existing = _.get(this.state, path, {});
			newVal = _.assign({}, existing, newVal);
			this.onChange(newVal, path);
		}
	};

	//- Dialog and saving
	closeSaveDocumentDialog = () => {
		this.setState({ isSaveDocumentDialogOpen: false });
	};

	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/accounting/bulkInvoices`);
	};

	closeSendConfirmationDialog = () => {
		this.setState({ isSendConfirmationOpen: false });
	};

	handleInvalidate = () => {
		this.setState({ isConfirmInvalidateOpen: true });
	};

	closeInvalidateDialog = () => {
		this.setState({ isConfirmInvalidateOpen: false });
	};

	//- New documents or updates to existing ones
	handleNewInvoiceDocuments = (r) => {
		const newInvoiceDocuments = r.invoiceDocuments;
		const existingInvoiceDocuments = this.state.invoiceDocuments;

		const newState = {};
		let invoiceDocuments = newInvoiceDocuments;
		existingInvoiceDocuments.forEach((existing) => {
			if (!_.find(invoiceDocuments, { invoiceDocumentId: existing.invoiceDocumentId })) {
				invoiceDocuments.push(existing);
			}
		});
		newState.invoiceDocuments = invoiceDocuments;

		//- Go through the new documents and set any values that are not set already
		//const invoiceDocuments = existingInvoiceDocuments.concat(newInvoiceDocuments);

		//- Go through all documents and get the which products
		const { bulkInvoice, bulkDeliveryMap } = this.props;
		const { linkedBulkDeliveryId } = bulkInvoice;
		const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

		if (!bulkDelivery) {
			this.setState({ errors: 'Missing linked bulk delivery' });
			return;
		}

		//- Special Case : If this is the INTERNAL terminal ID we don't require the delivery ticket
		//- so we default everything based on the bulk delivery
		const { pickupTerminalId, deliveryDate, carrierId } = bulkDelivery;
		if (pickupTerminalId === INTERNAL_TERMINAL_ID) {
			newState.carrierId = carrierId;
			newState.carrierPoNumber = deliveryDate;
			newState.deliveryDate = deliveryDate;
			newState.issueDate = deliveryDate;
		}

		invoiceDocuments.forEach((invoiceDocument) => {
			const { documentType, data } = invoiceDocument;

			//- Carrier
			if (documentType === 'carrierDeliveryTicket') {
				const { carrierId, carrierPoNumber, deliveryDate } = data;
				newState.carrierId = carrierId;
				newState.carrierPoNumber = carrierPoNumber;
				newState.deliveryDate = deliveryDate;
				newState.issueDate = deliveryDate;
			} else if (documentType === 'pickupBol') {
				//- XXX check if terminals / suppliers don't match across docs
				const { terminalSupplier, bolNumber, netGallons } = data;
				newState.pickupTerminalSupplier = terminalSupplier;

				//- Could be multiple docs so keep adding
				if (!newState.pickupBolNumbers) {
					newState.pickupBolNumbers = [];
				}
				newState.pickupBolNumbers.push(bolNumber);

				if (!newState.pickupNetGallons) {
					newState.pickupNetGallons = 0;
				}
				newState.pickupNetGallons += parseInt(netGallons, 10);
			} else if (documentType === 'offloadBol') {
				const { terminalId, bolNumber, netGallons } = data;
				newState.offloadTerminalId = terminalId;

				//- Could be multiple docs so keep adding
				if (!newState.offloadBolNumbers) {
					newState.offloadBolNumbers = [];
				}
				newState.offloadBolNumbers.push(bolNumber);

				if (!newState.offloadNetGallons) {
					newState.offloadNetGallons = 0;
				}
				newState.offloadNetGallons += parseInt(netGallons, 10);
			}
		});

		this.setState(newState);
	};

	handleDataFileUpload = ({ resource }) => {
		const { convertToPages, showErrors } = this.props;
		this.setState({ isConvertingToPages: true });
		convertToPages({
			params: {
				documentResourceId: resource.resourceId,
			},
			callback: (err, convertToPagesResult) => {
				const newState = {
					isConvertingToPages: false,
				};

				if (err) {
					this.setState(newState);
					return showErrors([err]);
				}

				newState.convertToPagesResult = convertToPagesResult;
				newState.isSaveDocumentDialogOpen = true;
				newState.invoiceDocumentsToModify = null;

				this.setState(newState);
			},
		});
	};

	handleRemoveInvoiceDocument = ({ invoiceDocumentId }) => {
		const { invoiceDocumentIds, invoiceDocuments } = this.state;

		const newInvoiceDocumentIds = _.filter(invoiceDocumentIds, (id) => {
			return id !== invoiceDocumentId;
		});

		const newInvoiceDocuments = _.filter(invoiceDocuments, (invoiceDocument) => {
			return invoiceDocument.invoiceDocumentId !== invoiceDocumentId;
		});

		this.setState({
			invoiceDocumentIds: newInvoiceDocumentIds,
			invoiceDocuments: newInvoiceDocuments,
		});
	};

	handleEditInvoiceDocument = ({ invoiceDocument }) => {
		const newState = {};
		newState.isSaveDocumentDialogOpen = true;
		newState.convertToPagesResult = null;
		newState.invoiceDocumentsToModify = [invoiceDocument];
		this.setState(newState);
	};

	onDocumentClick = (invoiceDocument) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: [invoiceDocument],
		});
	};

	handleCloseInvoiceDocumentPopupOpen = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: undefined,
		});
	};

	//
	// - Saving
	//
	handleSave = () => {
		const { showErrors } = this.props;

		this.save({
			callback: (err, r) => {
				if (err) {
					this.setState({ isSavingOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}

				const bulkInvoice = _.get(r, ['collections', 'bulkInvoiceCollection', 0]);
				if (!bulkInvoice) {
					this.setState({ isSavingOpen: false });
					return showErrors(['Save did not return bulk invoice']);
				}

				this.setState({
					bulkInvoiceForSending: bulkInvoice,
					savingStatus: 'done',
				});
			},
		});
	};

	handleSaveAndSend = () => {
		const { showErrors } = this.props;
		this.save({
			callback: (err, r) => {
				if (err) {
					this.setState({ isSavingOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}

				const bulkInvoice = _.get(r, ['collections', 'bulkInvoiceCollection', 0]);
				if (!bulkInvoice) {
					this.setState({ isSavingOpen: false });
					return showErrors(['Save did not return bulk invoice']);
				}

				this.setState({
					bulkInvoiceForSending: bulkInvoice,
					savingStatus: 'done',
				});

				setTimeout(() => {
					this.setState({
						isSavingOpen: false,
						isSendConfirmationOpen: true,
					});
				}, 500);
			},
		});
	};

	save = ({ callback }) => {
		const { updateBulkInvoice, bulkCustomerMap } = this.props;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		const bulkCustomerId = this.state.bulkCustomerId;
		if (!bulkCustomerId) {
			_setError(['bulkCustomerId'], `Bulk Customer is required`);
			this.setState({ formFieldError });
			return callback(errors);
		}

		const bulkCustomer = bulkCustomerMap[bulkCustomerId];
		if (!bulkCustomer) {
			return callback([`Bulk Customer ${bulkCustomerId} not found`]);
		}

		let fields = [
			{ fieldName: 'bulkCustomerId', display: 'Bulk Customer' },
			{ fieldName: 'issueDate', display: 'Issue Date' },
			{ fieldName: 'deliveryDate', display: 'Delivery Date' },
			{ fieldName: 'quickbooksTermId', display: 'Terms' },

			{ fieldName: 'carrierId', display: 'Carrier' },
			{ fieldName: 'carrierPoNumber', display: 'Delivery Ticket Number' },
			{ fieldName: 'offloadNetGallons', display: 'Offload Net Gallons' },
			{ fieldName: 'pickupNetGallons', display: 'Pickup Net Gallons' },
			{ fieldName: 'pickupTerminalSupplier', display: 'Pickup Terminal / Supplier' },
		];

		fields.forEach((s) => {
			if (!this.state[s.fieldName]) {
				_setError([s.fieldName], `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return callback(errors);
		}

		//- Get all the values and do individual checks
		const {
			bulkInvoiceId,

			issueDate,
			deliveryDate,
			quickbooksTermId,
			carrierId,
			carrierPoNumber,
			invoiceDocuments,

			offloadTerminalId,
			offloadBolNumbers,

			productType,
			pickupBolNumbers,

			pickupTerminalSupplier,

			bulkQuotedPriceId,
			requirePricingPerInvoice,
			requireLcfsCreditPrice,
		} = this.state;

		const pickupTerminalId = pickupTerminalSupplier.terminalId;
		const pickupSupplierId = pickupTerminalSupplier.supplierId;

		if (!pickupTerminalId || !pickupSupplierId) {
			_setError(['pickupTerminalSupplier'], `Pickup terminal / supplier is required`);
		}

		const lcfsCreditPrice = parseFloat(this.state.lcfsCreditPrice);
		const fuelPricePerGallon = parseFloat(this.state.fuelPricePerGallon);
		const pickupNetGallons = parseInt(this.state.pickupNetGallons, 10);
		const offloadNetGallons = parseInt(this.state.offloadNetGallons, 10);

		if (pickupNetGallons >= 10000) {
			_setError('pickupNetGallons', `Pickup net gallons above 10,000. Please recheck your values`);
		}

		if (offloadNetGallons >= 10000) {
			_setError(
				'offloadNetGallons',
				`Offload net gallons above 10,000. Please recheck your values`
			);
		}

		offloadBolNumbers.forEach((bolNumber, bIndex) => {
			if (!bolNumber) {
				_setError(['offloadBolNumbers', bIndex], 'BOL Number required');
			}
		});

		pickupBolNumbers.forEach((bolNumber, bIndex) => {
			if (!bolNumber) {
				_setError(['pickupBolNumbers', bIndex], 'BOL Number required');
			}
		});

		if (requirePricingPerInvoice) {
			if (!fuelPricePerGallon) {
				_setError('fuelPricePerGallon', `Invoice marked as requiring fuel price`);
			}
			if (fuelPricePerGallon > 5.0) {
				_setError('fuelPricePerGallon', `Fuel price is above 5.00. Please recheck your values.`);
			}
		} else {
			if (!bulkQuotedPriceId) {
				_setError('bulkQuotedPriceId', `Bulk quoted price marked as requiring fuel price`);
			}
		}

		if (requireLcfsCreditPrice) {
			if (_.isNil(lcfsCreditPrice)) {
				_setError('lcfsCreditPrice', `LCFS Credit Price is required.`);
			}

			if (!_.isFinite(lcfsCreditPrice)) {
				_setError('lcfsCreditPrice', `LCFS Credit Price must only contain digits and a period.`);
			}
		}

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return callback(errors);
		}

		const sortedInvoiceDocuments = _.orderBy(
			invoiceDocuments,
			({ documentType, name }) => {
				if (!documentType) {
					return 99;
				}
				return (documentTypeSort[documentType] || 98) + '_' + name;
			},
			'asc'
		);
		const invoiceDocumentIds = _.compact(_.map(sortedInvoiceDocuments, 'invoiceDocumentId'));

		//- Lock and load
		const params = {
			bulkInvoiceId,
			bulkCustomerId,
			issueDate,
			deliveryDate,
			quickbooksTermId,
			carrierId,
			carrierPoNumber,
			invoiceDocumentIds,

			productType,
			pickupTerminalId,
			pickupSupplierId,
			pickupBolNumbers,
			pickupNetGallons,

			offloadTerminalId,
			offloadBolNumbers,
			offloadNetGallons,
		};

		if (requirePricingPerInvoice) {
			params.fuelPricePerGallon = fuelPricePerGallon;
		} else {
			params.bulkQuotedPriceId = bulkQuotedPriceId;
		}

		if (requireLcfsCreditPrice) {
			params.lcfsCreditPrice = lcfsCreditPrice;
		}

		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		updateBulkInvoice({
			params,
			callback,
		});
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const {
			classes,
			bulkInvoice,
			carriers,
			bulkCustomers,
			terminals,
			showErrors,
			invalidateBulkInvoice,
			supplierMap,
			bulkDeliveryMap,
			resourceMap,
		} = this.props;

		const {
			isUpdate,
			bulkInvoiceId,
			isSaveDocumentDialogOpen,
			isSendConfirmationOpen,
			convertToPagesResult,
			invoiceDocumentsToModify,
			//formFieldError,

			//- Put here from initial load and from uploading new ones
			isSavingOpen,
			savingStatus,
			isConfirmInvalidateOpen,
			invoiceDocuments,
			errors,
			bulkInvoiceForSending,
		} = this.state;

		if (_.isEmpty(terminals) || _.isEmpty(carriers) || _.isEmpty(bulkCustomers) || !bulkInvoice) {
			return <div>Fetching information...</div>;
		}

		//- Figure out some shit and save it
		const linkedBulkDeliveryId = bulkInvoice.linkedBulkDeliveryId;
		const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

		if (!bulkDelivery) {
			return <div>Missing the linked bulk delivery {linkedBulkDeliveryId}</div>;
		}

		const { uploadedInvoiceDocuments, missingInvoiceDocuments } = getDocuments({
			invoiceDocuments, //- Ones we have
			bulkDelivery, //- Helps us determine ones we need
			carrierMap: _.keyBy(carriers, 'carrierId'),
			terminalMap: _.keyBy(terminals, 'terminalId'),
			supplierMap,
		});

		const isMissingRequiredDocs = !_.isEmpty(missingInvoiceDocuments);
		const headline = `Update Bulk Invoice #${bulkInvoiceId}`;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{!_.isEmpty(errors) && (
						<div className={classes.topErrors}>
							{errors.map((error) => {
								return error;
							})}
						</div>
					)}

					<FMPHeadline label={headline} />

					{this.renderBulkDelivery()}

					{this.renderInvoiceDocuments({
						uploadedInvoiceDocuments,
						missingInvoiceDocuments,
					})}

					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label="Invoice Info" />

						{!!bulkInvoice && this.displayStatus({ bulkInvoice })}

						{isMissingRequiredDocs && (
							<div className={classes.missingRequiredDocs}>
								Please first add all required delivery documents. Then the invoice information will
								be available.
							</div>
						)}

						{!isMissingRequiredDocs && this.renderInvoiceFields()}

						{this.renderButtons({
							isMissingRequiredDocs,
							bulkInvoice,
							isUpdate,
						})}
					</Paper>

					<GenericSavingDialog
						open={isSavingOpen}
						onClose={this.closeSavingDialog}
						onContinue={this.continueSavingDialog}
						processingText={'Processing and saving invoice.'}
						successText={'Invoice saved successfully.'}
						status={savingStatus}
					/>

					<ConfirmInvalidateBulkInvoiceDialog
						open={isConfirmInvalidateOpen}
						onClose={this.closeInvalidateDialog}
						bulkInvoice={bulkInvoice}
						invalidateBulkInvoice={invalidateBulkInvoice}
						showErrors={showErrors}
						history={this.props.history}
					/>

					<BulkInvoiceSendConfirmationDialog
						bulkInvoice={bulkInvoiceForSending}
						open={isSendConfirmationOpen}
						onClose={this.closeSendConfirmationDialog}
						history={this.props.history}
					/>

					<SaveInvoiceDocumentsDialog
						open={isSaveDocumentDialogOpen}
						onClose={this.closeSaveDocumentDialog}
						convertToPagesResult={convertToPagesResult}
						invoiceDocuments={invoiceDocumentsToModify}
						bulkDelivery={bulkDelivery}
						showErrors={showErrors}
						terminals={terminals}
						carriers={carriers}
						supplierMap={supplierMap}
						bulkDeliveryMap={bulkDeliveryMap}
						bulkInvoice={bulkInvoice}
						onNewInvoiceDocuments={this.handleNewInvoiceDocuments}
					/>

					<InvoiceDocumentPopup
						open={this.state.isInvoiceDocumentPopupOpen}
						onClose={this.handleCloseInvoiceDocumentPopupOpen}
						invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
						resourceMap={resourceMap}
					/>

					<InvoicePdfPopup
						open={this.state.isInvoicePdfPopupOpen}
						onClose={this.handleCloseInvoicePdfPopup}
						resourceId={this.state.invoicePdfPoppedUp}
						resourceMap={resourceMap}
					/>
				</Grid>
			</Grid>
		);
	}

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};
	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	displayStatus = ({ bulkInvoice }) => {
		const { classes } = this.props;
		const { status, invalidReason, collatedResourceId, quickbooksInvoiceUrl, total } = bulkInvoice;

		let invoiceTotal = <span>{moneyFormatter.format(total)}</span>;
		let onInvoiceClick = () => {
			this.onInvoiceClick(collatedResourceId);
		};
		return (
			<div style={{ padding: '10px', border: '1px solid #eee', display: 'flex' }}>
				<div>
					<div>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Invoice Status</div>
						<div style={invoiceStatusClassNames[status]}>{statusToDisplay[status]}</div>
					</div>
					{status === 'invalid' && !!invalidReason && (
						<div>
							<span>Invalid Reason: {invalidReason}</span>
						</div>
					)}
				</div>
				{!!invoiceTotal && (
					<div style={{ marginLeft: 20 }}>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Invoice Total</div>
						<div>{invoiceTotal}</div>
					</div>
				)}

				{!!collatedResourceId && (
					<div style={{ marginLeft: 20 }}>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Invoice PDF</div>
						<div className={classes.invoiceIcon} onClick={onInvoiceClick} />
					</div>
				)}

				{!!quickbooksInvoiceUrl && (
					<div style={{ marginLeft: 20 }}>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Quickbooks URL</div>
						<a href={quickbooksInvoiceUrl} target="_blank" rel="noreferrer noopener">
							<div className={classes.quickbooksIcon} />
						</a>
					</div>
				)}
			</div>
		);
	};

	renderBulkDelivery = () => {
		const {
			bulkDeliveryMap,
			classes,
			carriers,
			terminals,
			supplierMap,
			bulkInvoice,
			bulkCustomerMap,
		} = this.props;
		const { linkedBulkDeliveryId } = bulkInvoice;
		const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

		if (!bulkDelivery) {
			return <div>Missing the linked bulk delivery : #{linkedBulkDeliveryId}</div>;
		}

		const {
			deliveryDate,
			carrierId,
			status,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			productType,
		} = bulkDelivery;

		const deliveryDateFormatted = moment(deliveryDate).format('dddd, MMMM Do, YYYY');
		const carrier = _.find(carriers, { carrierId }) || { name: `Missing Carrier: ${carrierId}` };

		const pickupTerminal = _.find(terminals, { terminalId: pickupTerminalId }) || {
			name: `Missing pickup terminal :${pickupTerminalId}`,
		};

		const pickupSupplier = supplierMap[pickupSupplierId] || {
			name: `Missing pickup supplier:${pickupSupplierId}`,
		};

		const deliveryTerminal = _.find(terminals, { terminalId: deliveryTerminalId }) || {
			name: `Missing offload terminal :${deliveryTerminalId}`,
		};

		const bulkCustomer = bulkCustomerMap[deliveryBulkCustomerId] || {
			name: `Missing bulk customer :${deliveryBulkCustomerId}`,
		};

		const { statusClassName } = formatStatus(status);

		const productTypeDisplay = valueToDisplay(productType);

		return (
			<Accordion className={classes.paper} style={{ marginTop: 0, paddingBottom: 10 }}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: 0 }}>
					<FMPRegionHeader isTop={true} label={`Linked Delivery : #${linkedBulkDeliveryId}`} />
				</AccordionSummary>
				<AccordionDetails style={{ display: 'block' }}>
					<div className={classes.linkedTo}>
						<div>
							Linked to <strong>delivery #{linkedBulkDeliveryId}</strong>
						</div>
						<div className={classes.linkedStatus}>
							Status : <span className={classes[statusClassName]}>{status}</span>
						</div>
					</div>

					<FMPSectionHeader label={'Carrier'} />
					<div className={classes.inset}>
						<div>{carrier.name}</div>
					</div>

					<FMPSectionHeader label={'Delivery Date'} />
					<div className={classes.inset}>
						<div>{deliveryDateFormatted}</div>
					</div>

					<FMPSectionHeader label={'Fuel Pickup'} />
					<div className={classes.inset}>
						<div>Fuel : {productTypeDisplay}</div>
						<div>Terminal : {pickupTerminal.name}</div>
						<div>Supplier : {pickupSupplier.name}</div>
					</div>

					<FMPSectionHeader label={'Fuel Offload'} />
					<div className={classes.inset}>
						<div>Customer : {bulkCustomer.name}</div>
						<div>Terminal : {deliveryTerminal.name}</div>
					</div>
				</AccordionDetails>
			</Accordion>
		);
	};

	renderInvoiceDocuments = ({ uploadedInvoiceDocuments, missingInvoiceDocuments }) => {
		const { isDwp, classes, resourceMap } = this.props;

		const { isConvertingToPages } = this.state;

		const c = classes;
		return (
			<Paper className={classes.paper}>
				<FMPRegionHeader isTop={true} label="Delivery Documents" />

				<Grid container spacing={3}>
					<Grid item xs={12} md={4}>
						<ResourceUploader
							name={'dataFileResourceId'}
							label={''}
							afterUpload={this.handleDataFileUpload}
							onlyOne={true}
							customProgress={isConvertingToPages ? 'Converting...' : undefined}
						/>
					</Grid>
					<Grid item xs={12} md={8}>
						<div style={{ paddingTop: 10 }}>
							{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
								const { invoiceDocumentId, name, details, documentType } = invoiceDocument;

								return (
									<div className={classes.documentContainer} key={i}>
										<div className={classes.documentInfoContainer}>
											<InvoiceDocumentIcon
												invoiceDocument={invoiceDocument}
												resourceMap={resourceMap}
												onClick={this.onDocumentClick}
											/>

											<div className={c.documentInfo}>
												<div className={c.documentName}>{name || documentType}</div>
												<div className={c.documentDetails}>{details}</div>
											</div>
										</div>
										<div className={classes.documentIcons}>
											<IconButton
												aria-label="Edit"
												className={classes.button}
												onClick={() => {
													this.handleEditInvoiceDocument({ invoiceDocument });
												}}
											>
												<EditIcon />
											</IconButton>

											<IconButton
												aria-label="Delete"
												className={classes.button}
												onClick={() => {
													this.handleRemoveInvoiceDocument({ invoiceDocumentId });
												}}
											>
												<DeleteIcon />
											</IconButton>
										</div>
									</div>
								);
							})}

							{missingInvoiceDocuments.map((missingInvoiceDocument, j) => {
								const { isRequired, name } = missingInvoiceDocument;
								return (
									<div className={classes.documentContainer} key={j}>
										<div className={classes.documentInfoContainer}>
											<InvoiceDocumentIcon
												invoiceDocument={missingInvoiceDocument}
												isMissing={true}
											/>
											<div className={c.documentInfo}>
												<div className={c.missingDocumentName}>Need {name}</div>
												{isRequired && <div className={c.documentRequired}>*required</div>}
												{!isRequired && <div className={c.documentRequired}>*optional</div>}
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</Grid>
				</Grid>

				{isDwp && (
					<Grid container spacing={3}>
						<Grid item xs={6}>
							<Button
								onClick={() => {
									this.handleDataFileUpload({ resource: { resourceId: 888888888 } });
								}}
							>
								Test Document (only DWP sees this)
							</Button>
						</Grid>
					</Grid>
				)}
			</Paper>
		);
	};

	renderButtons = ({ isMissingRequiredDocs, bulkInvoice, isUpdate }) => {
		const status = _.get(bulkInvoice, ['status'], 'new');

		if (status === 'issued' && isUpdate) {
			return (
				<div style={{ textAlign: 'right', margin: '20px 10px' }}>
					<Button onClick={this.handleInvalidate} variant="outlined" style={{ margin: '0px 10px' }}>
						Mark Invalid
					</Button>

					<Button
						onClick={this.handleSave}
						variant="outlined"
						color="primary"
						style={{ margin: '0px 10px' }}
					>
						Save Invoice
					</Button>
				</div>
			);
		}

		return (
			<div style={{ textAlign: 'right', margin: '20px 10px' }}>
				<Button onClick={this.handleClose} variant="outlined" style={{ margin: '0px 10px' }}>
					Cancel
				</Button>

				<Button onClick={this.handleInvalidate} variant="outlined" style={{ margin: '0px 10px' }}>
					Mark Invalid
				</Button>

				<Button
					onClick={this.handleSave}
					variant="outlined"
					color="primary"
					style={{ margin: '0px 10px' }}
				>
					Save Invoice
				</Button>

				<FMPSubmitButton
					onClick={this.handleSaveAndSend}
					buttonText={`Save & Send Invoice`}
					isDisabled={isMissingRequiredDocs}
					disabledText={'Missing required delivery documents'}
				/>
			</div>
		);
	};

	renderInvoiceFields = () => {
		const {
			//classes,
			//bulkInvoice,
			//bulkDeliveryMap,
			bulkCustomers,
			quickbooksTerms,
		} = this.props;
		//const {} = this.state;

		return (
			<Fragment>
				<Grid container spacing={2}>
					<Grid item md={6} xs={12}>
						<FMPSectionHeader label={'Billing'} />
						<FMPBulkCustomerSelect
							path={'bulkCustomerId'}
							onChange={this.onChange}
							value={this.getValue('bulkCustomerId')}
							error={this.getError('bulkCustomerId')}
							bulkCustomers={bulkCustomers}
							readOnly={true}
							helpText={'Invoice is linked to bulk delivery. Customer can not be changed'}
						/>

						<FMPDatePicker
							label="Issue Date"
							path={'issueDate'}
							onChange={this.onChange}
							value={this.getValue('issueDate')}
							error={this.getError('issueDate')}
						/>

						<FMPQuickbooksTermSelect
							{...this.getInputProps('quickbooksTermId')}
							quickbooksTerms={quickbooksTerms}
						/>

						{this.renderCarrierSection()}
						{this.renderPricingSection()}
						{this.renderOffloadSection()}
						{this.renderPickupSection()}
					</Grid>
				</Grid>
			</Fragment>
		);
	};

	renderPricingSection = () => {
		const { classes } = this.props;

		const { bulkQuotedPrices, requirePricingPerInvoice, requireLcfsCreditPrice } = this.state;

		return (
			<div>
				<FMPSectionHeader label={'Pricing'} />
				{!requirePricingPerInvoice && (
					<FMPBulkQuotedPriceSelect
						path={'bulkQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('bulkQuotedPriceId')}
						error={this.getError('bulkQuotedPriceId')}
						bulkQuotedPrices={bulkQuotedPrices}
					/>
				)}
				{requirePricingPerInvoice && (
					<Fragment>
						<div className={classes.infoBox}>
							<InfoIcon className={classes.infoIcon} />
							<span>Marked as requiring fuel pricing per invoice.</span>
						</div>

						<FMPText
							label={`Fuel Price Per Gallon`}
							{...this.getInputProps('fuelPricePerGallon')}
						/>
					</Fragment>
				)}
				{requireLcfsCreditPrice && (
					<Fragment>
						<div className={classes.infoBox}>
							<InfoIcon className={classes.infoIcon} />
							<span>Supplier requires a lcfs credit amount per invoice.</span>
						</div>

						<FMPText label={`LCFS Credit Price`} {...this.getInputProps('lcfsCreditPrice')} />
					</Fragment>
				)}
			</div>
		);
	};

	renderMatch = (line) => {
		const { classes } = this.props;
		return (
			<div className={classes.matchRow}>
				<CheckIcon className={classes.checkIcon} />
				<span>{line}</span>
			</div>
		);
	};

	renderMismatch = (lines) => {
		const { classes } = this.props;
		return (
			<div className={classes.matchRow}>
				<WarningIcon className={classes.warningIcon} />
				<div>
					{lines.map((line, i) => {
						return <div key={i}>- {line}</div>;
					})}
				</div>
			</div>
		);
	};

	renderCarrierSection = () => {
		const { classes, bulkInvoice, bulkDeliveryMap, carriers } = this.props;
		const { invoiceDocuments, deliveryDate, carrierId } = this.state;

		const { linkedBulkDeliveryId } = bulkInvoice;
		const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

		//- Check if carrier matches delivery and the documents
		const deliveryCarrierId = bulkDelivery.carrierId;
		const deliveryCarrier = _.find(carriers, { carrierId: deliveryCarrierId }) || {
			name: `MISSING CARRIER: ${deliveryCarrierId}`,
		};

		let deliveryMatchSnippet =
			deliveryCarrierId === carrierId
				? this.renderMatch(`Carrier matches delivery`)
				: this.renderMismatch([`Carrier does not match delivery : ${deliveryCarrier.name}`]);

		//- Check if carrier matches document
		let documentCarrierId = 0;
		invoiceDocuments.forEach((invoiceDocument) => {
			const { documentType, data } = invoiceDocument;
			if (!data || documentType !== 'carrierDeliveryTicket') {
				return;
			}
			documentCarrierId = data.carrierId;
		});
		const documentCarrier = _.find(carriers, { carrierId: documentCarrierId }) || {
			name: `MISSING CARRIER: ${documentCarrierId}`,
		};
		let documentMatchSnippet = '';
		if (documentCarrierId === carrierId) {
			documentMatchSnippet = this.renderMatch(`Carrier matches delivery documents`);
		} else {
			documentMatchSnippet = this.renderMismatch([
				`Carrier does not match delivery documents : ${documentCarrier.name}`,
			]);
		}

		if (bulkDelivery.pickupTerminalId === INTERNAL_TERMINAL_ID) {
			documentMatchSnippet = this.renderMatch(
				'INTERNAL pickup does not require a carrier delivery document'
			);
		}

		//- See if the deliveryDate matches documents and delivery
		let deliveryDateMatchSnippet = '';
		if (bulkDelivery.deliveryDate === deliveryDate) {
			deliveryDateMatchSnippet = this.renderMatch(`Delivery date matches delivery.`);
		} else {
			deliveryDateMatchSnippet = this.renderMismatch([
				`Delivery date does not match delivery : ${bulkDelivery.deliveryDate}`,
			]);
		}

		return (
			<Fragment>
				<FMPSectionHeader label={'Carrier and Freight'} />

				<FMPCarrierSelect
					path={'carrierId'}
					onChange={this.onChange}
					value={this.getValue('carrierId')}
					error={this.getError('carrierId')}
					carriers={carriers}
				/>
				<div className={classes.matchContainer}>
					{deliveryMatchSnippet}
					{documentMatchSnippet}
				</div>

				<FMPText label={'Carrier PO Number'} {...this.getInputProps('carrierPoNumber')} />

				<FMPDatePicker
					label="Delivery Date"
					path={'deliveryDate'}
					onChange={this.onChange}
					value={this.getValue('deliveryDate')}
					error={this.getError('deliveryDate')}
				/>
				<div className={classes.matchContainer}>{deliveryDateMatchSnippet}</div>
			</Fragment>
		);
	};

	renderPickupSection = () => {
		const { classes, terminals, supplierMap } = this.props;
		const { invoiceDocuments, pickupBolNumbers } = this.state;

		/** @namespace this.state.pickupNetGallons **/
		const pickupNetGallons = parseInt(this.state.pickupNetGallons, 10);
		//- Check to see if everything matches delivery

		//const {linkedBulkDeliveryId } = bulkInvoice;
		//const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

		const min = MIN_GALLONS_FOR_BULK_WARNING;
		const max = MAX_GALLONS_FOR_BULK_WARNING;
		let deliveryMatchSnippet =
			pickupNetGallons >= min && pickupNetGallons <= max
				? this.renderMatch(`Net gallons within expected amounts of ${min} and ${max}`)
				: this.renderMismatch([`Net gallons outside normal amounts of ${min} and ${max}`]);

		//
		//- Calc what the delivery document thinks what is saved
		//

		//- Check if carrier matches document
		let documentPickupGallons = 0;
		invoiceDocuments.forEach((invoiceDocument) => {
			const { documentType, data } = invoiceDocument;
			if (!data || documentType !== 'pickupBol') {
				return;
			}
			const { netGallons } = data;
			documentPickupGallons += parseInt(netGallons, 10);
		});

		let documentMatchSnippet = '';
		if (documentPickupGallons === pickupNetGallons) {
			documentMatchSnippet = this.renderMatch(`Net gallons match amounts in delivery documents`);
		} else {
			documentMatchSnippet = this.renderMismatch([
				`Net gallons do not match amounts in delivery documents : ${documentPickupGallons}`,
			]);
		}

		const path = 'pickupTerminalSupplier';
		const val = _.get(this.state, path, DEFAULT_TERMINAL_SUPPLIER_VALUE);

		return (
			<Fragment>
				<FMPSectionHeader label={'Fuel Pickup'} />

				<FMPTerminalSupplierSelect
					label={`Pickup Terminal`}
					supplierLabel={`Pickup Supplier`}
					terminalId={val.terminalId}
					supplierId={val.supplierId}
					path={path}
					onChange={this.onTerminalSupplierChange}
					error={this.getError(path)}
					supplierError={this.getError(path)}
					terminals={terminals}
					supplierMap={supplierMap}
					productTypes={['etoh']}
					justBulk={true}
					md={12}
				/>

				{!_.isEmpty(pickupBolNumbers) &&
					pickupBolNumbers.map((bolNumber, bolIndex) => {
						const bolCount = pickupBolNumbers.length === 1 ? '' : ` #${bolIndex + 1}`;
						return (
							<FMPText
								key={bolIndex}
								label={`BOL Number${bolCount}`}
								{...this.getInputProps(`pickupBolNumbers.${bolIndex}`)}
							/>
						);
					})}

				<FMPText label={'Net Gallons'} {...this.getInputProps(`pickupNetGallons`)} />

				<div className={classes.matchContainer}>
					{deliveryMatchSnippet}
					{documentMatchSnippet}
				</div>
			</Fragment>
		);
	};

	renderOffloadSection = () => {
		const { classes, terminals } = this.props;
		const { invoiceDocuments, offloadBolNumbers } = this.state;

		/** @namespace this.state.offloadNetGallons **/
		const offloadNetGallons = parseInt(this.state.offloadNetGallons, 10);
		//- Check to see if everything matches delivery

		//const {linkedBulkDeliveryId } = bulkInvoice;
		//const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

		const min = MIN_GALLONS_FOR_BULK_WARNING;
		const max = MAX_GALLONS_FOR_BULK_WARNING;
		let deliveryMatchSnippet =
			offloadNetGallons >= min && offloadNetGallons <= max
				? this.renderMatch(`Net gallons within expected amounts of ${min} and ${max}`)
				: this.renderMismatch([`Net gallons outside normal amounts of ${min} and ${max}`]);

		//
		//- Calc what the delivery document thinks what is saved
		//

		//- Check if carrier matches document
		let documentOffloadGallons = 0;
		invoiceDocuments.forEach((invoiceDocument) => {
			const { documentType, data } = invoiceDocument;
			if (!data || documentType !== 'offloadBol') {
				return;
			}
			const { netGallons } = data;
			documentOffloadGallons += parseInt(netGallons, 10);
		});

		let documentMatchSnippet = '';
		if (documentOffloadGallons === offloadNetGallons) {
			documentMatchSnippet = this.renderMatch(`Net gallons match amounts in delivery documents`);
		} else {
			documentMatchSnippet = this.renderMismatch([
				`Net gallons do not match amounts in delivery documents : ${documentOffloadGallons}`,
			]);
		}

		return (
			<Fragment>
				<FMPSectionHeader label={'Fuel Offload'} />

				<FMPTerminalSelect
					label={`Offload Terminal`}
					{...this.getInputProps(`offloadTerminalId`)}
					terminals={terminals}
					productTypes={['etoh']}
					noFilter={true}
				/>

				{!_.isEmpty(offloadBolNumbers) &&
					offloadBolNumbers.map((bolNumber, bolIndex) => {
						const bolCount = offloadBolNumbers.length === 1 ? '' : ` #${bolIndex + 1}`;
						return (
							<FMPText
								key={bolIndex}
								label={`BOL Number${bolCount}`}
								{...this.getInputProps(`offloadBolNumbers.${bolIndex}`)}
							/>
						);
					})}

				<FMPText label={'Net Gallons'} {...this.getInputProps(`offloadNetGallons`)} />

				<div className={classes.matchContainer}>
					{deliveryMatchSnippet}
					{documentMatchSnippet}
				</div>
			</Fragment>
		);
	};
}

SaveBulkInvoice.propTypes = {
	isDwp: PropTypes.bool, //- from authUserContainer

	getBulkInvoice: PropTypes.func.isRequired,
	quickbooksCustomerMap: PropTypes.object,
	bulkInvoice: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,
	gasFormulaMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	resourceMap: PropTypes.object,

	updateBulkInvoice: PropTypes.func.isRequired,
	invalidateBulkInvoice: PropTypes.func.isRequired,

	searchBulkCustomers: PropTypes.func.isRequired,
	bulkCustomers: PropTypes.array,

	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,
	supplierMap: PropTypes.object,

	searchQuickbooksTerms: PropTypes.func.isRequired,
	quickbooksTerms: PropTypes.array,

	searchBulkQuotedPrices: PropTypes.func.isRequired,
	bulkQuotedPrices: PropTypes.array,

	convertToPages: PropTypes.func,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	BulkInvoiceContainer,
	BulkCustomersContainer,
	BulkQuotedPriceContainer,
	CarriersContainer,
	TerminalsContainer,
	DocumentContainer,
	QuickbooksContainer,
	AuthUserContainer,
])(SaveBulkInvoice);
